// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueTouch from 'vue-touch'
import Track from '@/plugins/Track'
import WxShare from '@/plugins/WxShare'
import NativeInterface from '@/plugins/NativeInterface'
import 'lib-flexible'
import App from '@/App'
import router from '@/router'
import store from '@/store'
import config from '@/config'
import { webpTest } from '@/utils'

Vue.config.productionTip = config.env === 'production'
Vue.use(VueTouch, {name: 'touch'})
// 使用自制的插件
Vue.use(Track, {
  appName: 'lls',
  appVersion: '5.8',
  category: 'web',
  basicParams: {
    campaign_name: 'tfchina'
  }
})
Vue.use(WxShare)
Vue.use(NativeInterface)

// 设置一些全局变量
Vue.prototype.global = {
  env: config.env
}

// 测试浏览器是否支持 webp
webpTest((boolean) => {
  if (boolean) {
    document.body.setAttribute('data-webp', 'support')
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js